<template>
  <div v-if="production" class="block-featured">
    <div class="featured-image-wrap">
      <Image
        v-if="coverImage"
        :filename="coverImage"
        :context="production"
        sizes="100vw"
      />
      <div class="featured-badge">
        <span v-if="production.number" class="show-number">{{ production.number }}</span>
        <span v-if="dateRange" class="date-range">{{ dateRange }}</span>
      </div>
    </div>
    <a :href="production.url" class="featured-link">
      <h2 class="featured-title">{{ production.title }}</h2>
    </a>
  </div>
</template>

<script setup>
import axios from 'axios'

const props = defineProps(['block'])
const lang = document.documentElement.lang

const production = ref(null)
const coverImage = computed(() => production.value?.images?.[0]?.filename)

const dateRange = computed(() => {
  const p = production.value
  if (!p) return ''
  return [shortDate(p.datestart), shortDate(p.dateend)].filter(Boolean).join('–')
})

function shortDate(str) {
  if (!str) return ''
  const d = new Date(str + 'T12:00:00')
  return isNaN(d) ? str : `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`
}

function refToQuery(ref) {
  return ref.startsWith('page://') ? `kirby.page("${ref}")` : `page("${ref}")`
}

onMounted(async () => {
  const refs = yamlToArray(props.block?.content?.page)
  const ref = refs[0]
  if (!ref) return

  const lc = (f) => lang ? `page.content("${lang}").${f}` : `page.content.${f}`
  const { data } = await axios.post('/api/cachedKQL', {
    select: {
      production: {
        query: refToQuery(ref),
        select: {
          title: lc('title'),
          url: lang ? `page.url("${lang}")` : true,
          number: lc('number'),
          datestart: lc('datestart'),
          dateend: lc('dateend'),
          images: {
            query: 'page.images',
            select: {
              filename: true, url: true,
              width: 'file.width()', height: 'file.height()',
              srcset: 'file.srcset([300,600,900,1200,1800,2200])',
              alt: 'file.alt',
            }
          }
        }
      }
    }
  })
  if (data.result?.production) production.value = cleanUpJSON(data.result.production)
})
</script>

<style scoped>
.block-featured {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.featured-image-wrap {
  position: relative;
}

.featured-badge {
  position: absolute;
  top: 0;
  right: 0;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.25rem;
}

.show-number {
  font-size: clamp(48px, 8vw, 120px);
  font-weight: 700;
  line-height: 1;
}

.date-range {
  font-size: 0.9rem;
  letter-spacing: 0.04em;
  opacity: 0.7;
}

.featured-link {
  display: block;
}

.featured-title {
  font-size: clamp(28px, 4vw, 64px);
  font-weight: 700;
  line-height: 1.1;
  margin: 0;
}
</style>
